import React from 'react';

const LpgIcon = (props) => {
  return (
    <img
      alt="Miejsce napełniania butli LPG"
      src="/static/images/icons/services/lpg.svg"
      {...props}
    />
  );
};

export default LpgIcon;
